export enum AccountType {
  INDIVIDUAL = 'INDIVIDUAL',
  TEAM = 'TEAM'
}
